import React from "react";
import { LOGO_URL } from "../lib/brand";

/**
 * Logo component.
 * variant="full" -> uses original logo image (Diesel & Dust WINDSCREENS) as a single image.
 * variant="group" -> shows the round emblem (cropped from logo) + custom "DIESEL & DUST GROUP" wordmark.
 */
export const Logo = ({ variant = "full", className = "", size = "md", dark = false }) => {
  const sizeMap = {
    sm: { h: 48, textMain: "text-xl sm:text-2xl", textSub: "text-base" },
    md: { h: 72, textMain: "text-3xl sm:text-4xl", textSub: "text-xl sm:text-2xl" },
    lg: { h: 112, textMain: "text-5xl sm:text-6xl", textSub: "text-3xl sm:text-4xl" },
  };
  const s = sizeMap[size] || sizeMap.md;
  const mainColor = dark ? "text-white" : "text-[var(--dd-ink)]";

  if (variant === "full") {
    return (
      <img
        src={LOGO_URL}
        alt="Diesel & Dust Windscreens"
        className={`object-contain ${className}`}
        style={{ height: s.h, width: "auto" }}
        data-testid="logo-full"
      />
    );
  }

  // GROUP variant: emblem (clipped) + custom text
  return (
    <div
      className={`flex items-center gap-3 ${className}`}
      data-testid="logo-group"
    >
      <div
        className="relative shrink-0 overflow-hidden rounded-full bg-white shadow-md"
        style={{ width: s.h, height: s.h }}
      >
        <img
          src={LOGO_URL}
          alt=""
          aria-hidden="true"
          className="absolute top-0 left-0 h-full"
          style={{
            width: "auto",
            maxWidth: "none",
            objectFit: "cover",
            objectPosition: "left center",
            transform: "scale(1.12)",
            transformOrigin: "left center",
          }}
        />
      </div>
      <div className="flex flex-col leading-none">
        <span
          className={`font-display font-black uppercase tracking-tight ${mainColor} ${s.textMain}`}
          style={{ letterSpacing: "0.01em" }}
        >
          Diesel <span className="text-[#f28a16]">&</span> Dust
        </span>
        <span
          className={`font-display font-black uppercase text-[#f28a16] tracking-[0.28em] mt-1.5 ${s.textSub}`}
        >
          Group
        </span>
      </div>
    </div>
  );
};

export default Logo;
